import { ApproverTaskItem } from '../../../../../domains/approver-review/interfaces/interfaces';
import { ChangeApproverTask } from './ChangeApproverTask/ChangeApproverTask';

export enum ActionTaskEnum {
  PENDING = 'pending',
  PROGRESS = 'progress',
}

interface ApproverTaskActionProps {
  approverTask: ApproverTaskItem;
}

export const ApproverTaskAction = ({
  approverTask,
}: ApproverTaskActionProps) => {
  return (
    <div>
      <ChangeApproverTask approverTask={approverTask} />
    </div>
  );
};
